// src/vocabulary/C1/unit1/questions.js

const questions = [
  // 🟢 Understanding meaning
  {
    id: 1,
    type: "choice",
    question: "What does 'identity' mainly refer to?",
    options: [
      "A physical object",
      "Who a person is",
      "A temporary decision"
    ],
    correctAnswer: "Who a person is"
  },

  {
    id: 2,
    type: "choice",
    question: "Which word is closest in meaning to 'purpose'?",
    options: [
      "Goal",
      "Problem",
      "Mistake"
    ],
    correctAnswer: "Goal"
  },

  // 🟡 Usage & nuance
  {
    id: 3,
    type: "choice",
    question: "Choose the most accurate sentence:",
    options: [
      "Freedom without responsibility can be dangerous.",
      "Freedom is dangerous responsibility.",
      "Freedom dangerous without."
    ],
    correctAnswer: "Freedom without responsibility can be dangerous."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence shows an abstract idea?",
    options: [
      "The book is on the table.",
      "Success is hard to define.",
      "The car is very fast."
    ],
    correctAnswer: "Success is hard to define."
  },

  // 🔵 Critical thinking
  {
    id: 5,
    type: "choice",
    question: "Why can failure be useful?",
    options: [
      "Because it ends effort",
      "Because it teaches lessons",
      "Because it avoids responsibility"
    ],
    correctAnswer: "Because it teaches lessons"
  },

  {
    id: 6,
    type: "choice",
    question: "Which sentence best reflects a C1-level idea?",
    options: [
      "I want to be successful.",
      "Success depends on personal values.",
      "Success is good."
    ],
    correctAnswer: "Success depends on personal values."
  }
];

export default questions;


